import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';

import CustomReminderAPI from '../../../api/CustomReminderAPI';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import FieldController from '../../../controller/FieldController';
import Util from '../../../util/Util';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';
import Scheduler from '../automation/Scheduler';
import AutomationModuleSelect from '../automation/AutomationModuleSelect';

class CustomReminderUpdate extends React.Component {

  static Options = [ 
    { label: 'Before Selected Time', value: 1 },
    { label: 'After Selected Time', value: 2 } 
  ];

  constructor(props) {
    super(props);
    const id = parseInt(props.match.params.id);
    this.state = {
      inApiCall: id !== 0, id: id, name: '', description: '', model: '', field: '',
      automations: [null],
      execute_type: '', execute: 0, execute_select: '', changed: false
    };
    this.mainModel = reactLocalStorage.getObject(Const.Model);
    this.Automations = this.mainModel.automation.options;
    this.fieldList = [];

    this.basePath = this.props.match.path
    this.basePath = this.basePath.substring(0, this.basePath.lastIndexOf('/'));
  }

  componentDidMount() {
    if (this.state.id !== 0) CustomReminderAPI.get(this.state.id, this.onReceived, this.onFail);
  }
  onFail = () => this.setState({ inApiCall: false });

  onReceived = reminder => {
    const model = Object.keys(this.mainModel).find(i => this.mainModel[i].model_no === reminder.model);
    this.fieldList = [];
    const fields = FieldController.getFilterFields(this.mainModel[model].fields);
    for(let i = 0; i < fields.length; i++) {
      const type = fields[i].field_type;
      if(type === Const.Date || type === Const.DateTime) {
        this.fieldList.push({ id: fields[i].id, value: fields[i].fieldKey,
          type, label: fields[i].label_name });
      }
    }

    const automations = this.Automations.filter(auto => 
      reminder.automations.includes(`${Const.Opt}${auto.value}${Const.Opt}`));

    this.setState({ ...this.state,
      name: reminder.name,
      description: reminder.description,
      model,
      field: this.fieldList.find(field => field.value === reminder.field_name),
      execute_type: CustomReminderUpdate.Options.find(i => i.value === reminder.execute_type),
      execute: reminder.execute,
      execute_select: Scheduler.Options.find(i => i.value === reminder.execute_select),
      automations: automations && automations.length > 0 ? automations : [{}],
      inApiCall: false
    });
  }

  nameChange = event => this.setState({ ...this.state, name: event.target.value });
  desChange = event => this.setState({ ...this.state, description: event.target.value });

  onSave = () => {
    this.setState({ ...this.state, inApiCall: true });
    const reminder = {
      id: this.state.id,
      name: this.state.name,
      description: this.state.description,
      model: this.mainModel[this.state.model].model_no,
      field_name: this.state.field.value,
      execute_type: this.state.execute_type.value,
      execute: this.state.execute,
      execute_select: this.state.execute_select.value,
      automations: Const.Opt
        + this.state.automations.map(auto => auto.value).join(Const.Opt) + Const.Opt
    };
    CustomReminderAPI.save(reminder, this.onSaved, this.onFail);
  }

  onSaved = () => {
    Util.showNotification('Successful', 'Successfully saved.', 'success');
    this.props.navigate(this.basePath);
  }

  render() {
    const assignments = this.state.automations.map((auto, i) => 
      <div key={`assign_users_${i}`} className="col-md-12 condition-select-div">
        <div className="col-md-4">
          <Select value={auto} className="mr-sm-2 assignselect"
            options={this.Automations} isSearchable={true} isMulti={false}
            onChange={auto => {
              const automations = [ ...this.state.automations ];
              automations[i] = auto;
              this.setState({ ...this.state, automations });
            }} />
        </div>
        { Display.MultiAction(i, 
          () => this.setState({ ...this.state, automations: [ ...this.state.automations, null] }),
          i => {
            const automations = [ ...this.state.automations];
            this.setState({ ...this.state, automations: automations.filter((_, j) => i !== j)})
          }
        )}
      </div>
    );
    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <div className="row"><div className="col-md-12"><h3>Custom Reminder</h3></div></div>
          <ApiUiController inApiCall={this.props.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <div className="col-md-6">
                <div className="form-group">
                  <FormControl type='text' placeholder='Name'
                    className="mr-sm-2" value={this.state.name} onChange={this.nameChange} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <Form.Group className="mb-3">
                    <Form.Label>Discription</Form.Label>
                    <Form.Control as="textarea" rows={3}
                      className="mr-sm-2" value={this.state.description} onChange={this.desChange} />
                  </Form.Group>
                </div>
              </div>
              <div className="formhead col-md-6">
                <h4>Module</h4>
                <AutomationModuleSelect
                  model={this.state.model}
                  onChange={(_, model) => {
                    this.fieldList = [];
                    if(model) {
                      const fields = FieldController.getFilterFields(this.mainModel[model].fields);
                      for(let i = 0; i < fields.length; i++) {
                        const type = fields[i].field_type;
                        if(type === Const.Date || type === Const.DateTime) {
                          this.fieldList.push({ id: fields[i].id, value: fields[i].fieldKey,
                            type, label: fields[i].label_name });
                        }
                      }
                    }
                    this.setState({ ...this.state, model });
                  }}
                  models={this.mainModel}
                  size={6} />
              </div>

              <div className="formhead col-md-6">
                <h4>Module Field</h4>
                <Select value={this.state.field} className="mr-sm-1"
                  onChange={selected => this.setState({ ...this.state, field: selected })}
                  options={this.fieldList} isSearchable={true} isClearable={true} />
              </div>

              <div className="formhead col-md-12"> 
                <h4>Scheduled Actions</h4>
              </div>
              <div className="col-md-12 display-flixr">
                <div className='col-md-4'>
                  <Select
                    value={this.state.execute_type}
                    options={CustomReminderUpdate.Options} isSearchable={false} isClearable={false}
                    onChange={execute_type => this.setState({ ...this.state, execute_type})} />
                </div>
                <div className='col-md-4'>
                  <FormControl type="number" placeholder="Number" value={this.state.execute}
                    onChange={evt => this.setState({ ...this.state, execute: evt.target.value})}/>
                </div>
                <div className='col-md-4'>
                  <Select value={this.state.execute_select} options={Scheduler.Options}
                    isSearchable={false} isClearable={false}
                    onChange={execute_select => this.setState({ ...this.state, execute_select})} />
                </div>
              </div>

              <div className="formhead col-md-12">
                <h4>Execute Automations</h4>
              </div>
              {assignments}

              <div className="col-md-12 text-center btnsend">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(CustomReminderUpdate);
